import { deliverableApi, employeeApi, expertApi, feeApi, projectApi } from '@atheneum/api'
import Fee from '@models/Fee'
import { extendObservable } from 'mobx'

class FeeFormStore {
  constructor(staticData, fee, project) {
    extendObservable(this, {
      loading: true,
      teamInfosLoading: false,
      error: null,
      staticData,
      fee,
      project,
      projectDeliverables: [],
      applicableContracts: [],
      employees: [],
      teamInfos: []
    })

    this.loadData()
  }

  loadData() {
    Promise.all([
      this.loadProjectDeliverables(),
      this.loadProjectApplicableContracts(),
      this.loadEmployees()
    ])
      .then(([deliverables, applicableContracts, employees]) => {
        this.projectDeliverables.replace(deliverables)
        this.applicableContracts.replace(applicableContracts)
        this.employees.replace(employees)
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  async loadProjectDeliverables() {
    const deliverables = await deliverableApi.getProjectDeliverables(this.project.id, {
      paygOnly: false
    })
    return deliverables
  }

  async loadProjectApplicableContracts() {
    const applicableContracts = await projectApi.getApplicableContracts(
      this.project.id
    )
    return applicableContracts
  }

  async loadEmployees() {
    let employees = await employeeApi.getAll()
    employees = employees.map(e => {
      return {
        value: e.id,
        label: e.fullName,
        active: !!e.status,
        positionId: e.employeePositionId
      }
    })
    return employees
  }

  async loadTeamInfoForEmployees() {
    this.teamInfosLoading = true
    const teamInfos = await employeeApi.getTeamInfo([this.fee.deliveredBy])
    this.teamInfos.replace(teamInfos)
    this.teamInfosLoading = false
  }

  save(feeData) {
    this.fee = new Fee(feeData, this.staticData)
    return this.fee.id ? this.update() : this.create()
  }

  create() {
    return feeApi.createFee(this.fee.payload)
  }

  update() {
    return feeApi.updateFee(this.fee.id, this.fee.payload)
  }

  saveFeeInBackdating(feeId, feeData) {
    return feeApi.saveBackdatingFee(feeId, feeData)
  }

  getEmployeesByPosition(positions, userIds = []) {
    return this.employees
      .filter(
        e =>
          (e.active && positions.includes(e.positionId)) ||
          userIds.includes(e.value)
      )
      .map(e => {
        return {
          id: e.value,
          name: e.label
        }
      })
  }

  getUnitsOfWork(feeData) {
    const fee = new Fee(feeData, this.staticData)
    return feeApi.getUnitValues(fee.payload)
  }

  expertTypeahead(q) {
    return expertApi.typeahead(q).then(experts => {
      return {
        options: experts.map(e => ({
          value: e.id,
          label: `${e.fullName} [${e.expert.expertCode}]`
        }))
      }
    })
  }
}

export default FeeFormStore
